<template>
    <div v-loading="loading">
        <CardThreeContactList
            :card="cardObj"
            :recordIdStr="record7Str"
            @goChat="goChatCallback"
            v-if="null != cardObj"
        />
    </div>
</template>

<script setup>
    import CardThreeContactList from "@/plugins/projectA/ui/cardThreeContactList.vue";
    import {onBeforeMount, ref} from "vue";
    import cardApi from "@/request/api";
    import myUtil from "@/util/util";
    import record7Api from "@/request/record7Api";

    const props = defineProps(["cardId"])
    const emits = defineEmits(["goShopopeeChat"])

    const loading = ref(false)

    const cardObj = ref(null)
    const record7List = ref([])
    const record7Str = ref(null)

    function getCardInfo(){
        loading.value = true

        const request = cardApi.queryMemberWorkById
        const params = request.getParams()

        params.id = props.cardId

        request.send(params, (res) => {
            if (res.code == 200){
                cardObj.value = res.detail

                record7Str.value = cardObj.value.addinfo1
                // if (myUtil.isNotEmpty(cardObj.value.addinfo1)){
                //     getRecord17List()
                // }else{
                    loading.value = false
                // }

            }else{
                myUtil.alertError(res.msg)
            }
        })

    }

    function getRecord17List(){
        let ids = cardObj.value.addinfo1

        ids = ids.split(",")

        const request = record7Api.getAdditionalrecord7List
        const params = request.getParams()

        params.group = ids

        request.send(params, (res) => {
            loading.value = false

            if (res.code == 200){
                record7List.value = res.detail

            }else{
                myUtil.alertError(res.msg)
            }
        })

    }

    function goChatCallback(){
        emits("goShopopeeChat", cardObj.value)
    }

    onBeforeMount(() => {
        getCardInfo()
    })

</script>

<style scoped>

</style>